export function IconRemove() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" d="M1 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1z"/>
        </svg>
    );
}
